import React from 'react';
import { t, translate } from 'react-switch-lang';
import { observer } from 'mobx-react';
import seven from '../../../../../theme/theme/src/assets/images/user/7.jpg';
import usersStorage from './usersStorage';
import UserFieldEdit from './UserFieldEdit';
import DeleteButton from '../../components/buttons/DeleteButton';
import LockedButton from '../../components/buttons/LockedButton';
import UnlockedButton from '../../components/buttons/UnlockedButton';
import SaveButton from '../../components/buttons/SaveButton';
import SelectInput from '../../components/forms/SelectInput';
import RestoreButton from '../../components/buttons/RestoreButton';
import Divider from '../../components/Divider';
import dictionaries from '../../storages/mobx/dictionaries';
import PasswordResetButton from '../../components/buttons/PasswordResetButton';
import CrossCloseButton from '../../auth/components/CrossCloseButton';
import { Cancel, ModalTitle, SaveChanges } from '../../../../../theme/theme/src/constant';
import ChangeUserPhoto from '../../components/images/ChangeableImage';
import perfectumStorage from '../../storages/external/perfectum';

function ShortUserCard({ t }) {
  if (!usersStorage.currentUser) return <div>No user selected</div>;
  return (
    <div>
      <div className="row mb-2">
        <div className="col-auto" onClick={() => usersStorage.toggleAddPhotoDialog()}>
          <img className="img-70 rounded-circle" alt="" src={usersStorage.selectedUser.avatar || seven} />
        </div>
        <div className="col">
          <h4 className="mb-1">
            {usersStorage.selectedUser.name ? ` ${usersStorage.selectedUser.name}` : ''}
            {usersStorage.selectedUser.soname ? ` ${usersStorage.selectedUser.soname}` : ''}
            {usersStorage.selectedUser.surname ? ` ${usersStorage.selectedUser.surname}` : ''}
          </h4>
          <p className="mb-4">{usersStorage.selectedUser.staffName}</p>
        </div>
      </div>
      <div className="row mb-2 btn-group">
        {!usersStorage.selectedUser.deleted_at
        && (
          <DeleteButton
            onClick={() => usersStorage.deleteUser(usersStorage.selectedUser.id)}
            id={`users-delete-2-button-${usersStorage.selectedUser.id}`}
            text={t('users.Delete')}
          />
        )}
        {usersStorage.selectedUser.deleted_at
        && (
          <RestoreButton
            onClick={() => usersStorage.restoreUser(usersStorage.selectedUser.id)}
            id={`users-restore-2-button-${usersStorage.selectedUser.id}`}
            text={t('users.Restore')}
          />
        )}
        {usersStorage.selectedUser.status == -1 && <LockedButton onClick={() => usersStorage.unbanUser(usersStorage.selectedUser.id)} id="users-locked-button" text={t('users.User locked, unlock it')} />}
        {usersStorage.selectedUser.status != -1 && <UnlockedButton onClick={() => usersStorage.banUser(usersStorage.selectedUser.id)} id="users-unlocked-button" text={t('users.User unlocked, Lock it!')} />}
        {usersStorage.haveChanges && <SaveButton onClick={usersStorage.saveUsersChanges} id="users-save-button" text={t('users.User changed')} />}
      </div>
      <Divider text={t("users.User's data")} />
      {!usersStorage.selectedUser.isUserDeleted && (
        <>
          <div className="col">
            <fieldset className="form-group">
              <UserFieldEdit
                onChange={(e) => usersStorage.changeUserField(usersStorage.currentUser, 'name', e.target.value)}
                value={usersStorage.selectedUser.name}
                placeholder={t('users.name')}
                id={usersStorage.currentUser}
                field="name"
              />
              <UserFieldEdit
                value={usersStorage.selectedUser.soname}
                placeholder={t('users.soname')}
                id={usersStorage.currentUser}
                field="soname"
              />
              <UserFieldEdit
                value={usersStorage.selectedUser.surname}
                placeholder={t('users.surname')}
                id={usersStorage.currentUser}
                field="surname"
              />
              <UserFieldEdit
                value={usersStorage.selectedUser.email}
                placeholder={t('users.email')}
                id={usersStorage.currentUser}
                field="email"
              />
              <UserFieldEdit
                value={usersStorage.selectedUser.staffName}
                placeholder={t('users.staffName')}
                id={usersStorage.currentUser}
                field="staffName"
              />
              {/*<UserFieldEdit*/}
              {/*  value={usersStorage.selectedUser.perfectum_id}*/}
              {/*  placeholder={t('users.crmId')}*/}
              {/*  id={usersStorage.currentUser}*/}
              {/*  field="perfectum_id"*/}
              {/*/>*/}
              <SelectInput
                label={t('users.crmId')}
                onChange={(e) => usersStorage.changeUserField(usersStorage.currentUser, 'perfectum_id', e.target.value)}
                value={usersStorage.selectedUser.perfectum_id}
              >
                <option value={null}>{t('users.select_user')}</option>
                {perfectumStorage.staff
                  ?.map((staff) => (
                    <option value={staff.userId}>
                      {usersStorage.selectedUser.email === staff.data.email ? `[+] ${staff.fullName}` : staff.fullName}
                    </option>
                  ))}
              </SelectInput>
              <SelectInput
                label={t('users.User group')}
                onChange={(e) => usersStorage.changeUserField(usersStorage.currentUser, 'group_id', e.target.value)}
                value={usersStorage.selectedUser.group_id}
              >
                <option value="0">{t('users.not verified')}</option>
                {Object.keys(dictionaries.userGroups).map((optionID) => <option value={optionID}>{t(dictionaries.userGroups[optionID])}</option>)}
              </SelectInput>
              <PasswordResetButton id={usersStorage.currentUser} />
            </fieldset>
          </div>
        </>
      )}
      {/* <div className="row mb-2"> */}
      {/*  <h5>Additional</h5> */}
      {/* </div> */}
      {/* <div className="row mb-2"> */}
      {/*  <h5>Contacts</h5> */}
      {/* </div> */}
      {/* <div className="row mb-2"> */}
      {/*  <h5>Conversations</h5> */}
      {/* </div> */}
      {/* <div className="row mb-2"> */}
      {/*  <h5>Orders</h5> */}
      {/* </div> */}
      <CrossCloseButton onClick={() => usersStorage.setCurrentUser(null)} />
      <ChangeUserPhoto
        opened={usersStorage.addPhotoDialogOpened}
        toggle={usersStorage.toggleAddPhotoDialog}
        onSave={usersStorage.saveUserAvatar}
        getUploadParams={usersStorage.getUploadParams}
        handleUpload={usersStorage.handleChangeStatus}
        cancelText={t('Cancel')}
        saveText={t('SaveChanges')}
      />
      {usersStorage.addPhotoDialogOpened && <div>Open photo dialog</div>}
    </div>
  );
}

ShortUserCard.propTypes = {};

export default translate(observer(ShortUserCard));
